import React, {Component} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import styled, {css} from 'styled-components';

// styles
import style from '../../Styles/Containers/Modal_Barcode.module.css'

//modal
import ModalBarcodeComponent from '../../Components/modal/ModalBarcode'

const Logo = styled.div`
    width: 208px;
    height: 42px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    ${props => css`background-image: url("${props.imgSrc}");`}
    margin: 0 auto;
`

const TextProduct = styled.div`
    text-align: center;
    width: 201px;
    margin: 36px auto 0;
    .name {
        font-size: 26px;
        font-weight: 700;
        line-height: 1.2;
        color: #333;
    }
    .detail {
        margin-top: 12px;
        font-size: 14px;
        line-height: 1.2;
        color: #555;
    }
`

const ImageProduct = styled.div`
    margin-top: 12px;
    width: 100%;
    
    .image {
        width: 120px;
        height: 120px;
        margin: 0 auto;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        ${props => css`background-image: url("${props.imgSrc}");`}
    }
    .name {
        margin: 12px auto 0;
        width: 201px;
        color: #555;
        font-size: 14px;
        line-height: 18px;
    }
`

const ProductCode = styled.div`
    width: 201px;
    padding: 14px; 0;
    text-align: center;
    margin: 0 auto;
    .title {
        font-size: 16px;
        font-weight: 700;
        color: #333;
        line-height: 1.2;
    }
    .content {
        margin-top: 4px;
        font-size: 16px;
        color: #555;
        line-height: 1.2;
     }
`

const Barcode = styled.div`    
    .image {
        width: 201px;
        height: 80px;
        margin: 25.5px auto;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        ${props => css`background-image: url("${props.imgSrc}");`}
    }
`


class ModalBarcodeContainer extends Component {
    constructor() {
        super();
        this.state = {
            showModal: true,
            selectedItem: {},
        }
    }

    componentDidMount() {
        console.log(this.props, '123');
        this.setState({
            locale: (this.props.eSESSION.user || {}).ELocale,
            selectedItem: this.props.selectedItem,
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedItem !== this.props.selectedItem) {
            this.setState({ selectedItem: this.props.selectedItem || {}, }, () => {
                console.log(this.state);
            })
        }
    }

    render() {
        const renderProduct = (eventPrize) => {
            if (eventPrize.EPrizeType == 'image') {
                return (
                    <ImageProduct imgSrc={eventPrize.image}>
                        <div className={'image'}/>
                        <div className={'name'}>
                            {eventPrize.name}
                        </div>
                    </ImageProduct>
                )
            } else {
                return (
                    <TextProduct>
                        <div className={'name'}>
                            {eventPrize.name}
                        </div>
                        <div className={'detail'}>
                            {eventPrize.detail}
                        </div>
                    </TextProduct>
                )
            }
        }

        const renderCode = (eventPrize) => {
            if (eventPrize.barcodeUrl) {
                return (
                    <Barcode imgSrc={eventPrize.barcodeUrl}>
                        <div className={'image'}/>
                    </Barcode>
                )
            } else {
                return (
                    <ProductCode>
                        <div className={'title'}>프로모션 코드</div>
                        <div className={'content'}>{eventPrize.promotionCode}</div>
                    </ProductCode>
                )
            }
        }

        return (
            <div>
            <ModalBarcodeComponent 
                visible={this.props.showModal}                              //true를 넘기면 팝업이 열리고 false를 넘기면 닫힘
                topImage={<Logo imgSrc={this.props.selectedItem.companyLogoUrl || ''}/>}
                topContent={this.state.selectedItem.companyName}
                middleContent={renderProduct(this.state.selectedItem.eventPrize || {})}
                bottomContent={renderCode(this.state.selectedItem.eventPrize || {})}
                handleModal={this.props.handleModal}
                />
            </div>

        )
    }
}

export default connect((state) => {
    return {
        eSESSION: state.data.eSESSION.eSESSION,
    }
})(withRouter(ModalBarcodeContainer));